import { mapParamsBySchema, mapRowsBySchema } from '../../util';
import { apiRequest } from '../../Services/Common/ApiRequest';
import Global from '../../Services/Common/Global';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../Hooks/apis/useQuriesSuccess';
import useSaveMutation from '../../Hooks/apis/useSaveMutaion';
import { M_ALL_BASIC_Schema } from './M_ALL_BASIC_Schema';
import useDeleteMutation from '../../Hooks/apis/useDeleteMutaion';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_ALL_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['Alarm', 'GetAlarmList', params],
    queryFn: () => apiRequest('post', Global.urls.Alarm.GetAlarmList, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const requestAlarmRead = async (context) => {
  const payload = mapParamsBySchema(M_ALL_BASIC_Schema.mapper.save1, context);
  console.log('[Alarm] SaveAllBasicU1 request', {
    alarmCd: context.alarmCd,
    url: Global.urls.Alarm.SaveAllBasicU1,
    payload,
  });
  const response = await apiRequest(
    'post',
    Global.urls.Alarm.SaveAllBasicU1,
    payload
  );
  console.log('[Alarm] SaveAllBasicU1 response', response);
  return response;
};

export const useSave1 = (options = {}) =>
  useSaveMutation(requestAlarmRead, options);

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_ALL_BASIC_Schema.mapper.delete1);
    return apiRequest('post1', Global.urls.Alarm.DeleteAlarmD1, payload);
  }, options);
};
